<template>
  <div class="inner-card">
    <slot />
  </div>
</template>

<script>
export default {
  name: "InnerCard"
};
</script>

<style lang="scss">
.inner-card {
  background-color: colors(palette-2);
  box-shadow: 0px 14px 25px 0px #01141a;
  border-radius: 5px;
  padding: 20px 25px;

  @media (max-width: 410px) {
    padding: 10px;
  }
}
</style>
